import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import type { PlanV2IssueDispositionRecord } from '../../utils/plan-v2-issues';
import {
  competitorPageLinkLabel,
  competitorPagePath,
  freshnessParagraphsForDisplay,
  sectionHeadingLevelChip,
  supportingGapDisplayBlocks,
  technicalWorkItemGuidance,
  technicalIssueDisplayTitle,
  workItemChipLabel,
  workItemDetailFor,
  workItemExampleEntries,
  type PlanV2WorkItemDetailV1,
  type SupportingGapDisplayBlock
} from '../../utils/plan-v2-work-item-display';
import {
  formatInternalLinkRelevanceScore,
  internalLinkDirectionChipClass,
  internalLinkDirectionLabel,
  type InternalLinkDirection
} from '../../utils/plan-v2-work-item-compose';

@Component({
  selector: 'app-plan-v2-work-item-body',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './plan-v2-work-item-body.html',
  styleUrl: './plan-v2-work-item-body.css'
})
export class PlanV2WorkItemBodyComponent {
  @Input({ required: true }) item!: PlanV2IssueDispositionRecord;

  chipLabel(): string {
    return workItemChipLabel(this.item);
  }

  detail(): PlanV2WorkItemDetailV1 | null {
    return workItemDetailFor(this.item);
  }

  examples(): Array<{ term: string; lines: string[] }> {
    return workItemExampleEntries(this.detail());
  }

  hasStructuredBody(): boolean {
    return Boolean(this.detail());
  }

  internalLinkDirectionChip(direction: InternalLinkDirection): string {
    return internalLinkDirectionLabel(direction);
  }

  internalLinkDirectionChipClasses(direction: InternalLinkDirection): string {
    return internalLinkDirectionChipClass(direction);
  }

  formatInternalLinkScore(score: number): string {
    return formatInternalLinkRelevanceScore(score);
  }

  freshnessParagraphs(): string[] {
    return freshnessParagraphsForDisplay(this.detail()?.freshness?.paragraphs);
  }

  supportingGapBlocks(): SupportingGapDisplayBlock[] {
    const gaps = this.detail()?.supportingGaps;
    return gaps?.length ? supportingGapDisplayBlocks(gaps) : [];
  }

  competitorPagePath(url: string): string {
    return competitorPagePath(url);
  }

  competitorPageLinkLabel(url: string): string {
    return competitorPageLinkLabel(url);
  }

  technicalGuidance(title: string): string | null {
    return technicalWorkItemGuidance(title);
  }

  technicalIssueTitle(title: string): string {
    return technicalIssueDisplayTitle(title);
  }

  readonly sectionHeadingLevelChip = sectionHeadingLevelChip;
}
